import { ExternalLink, X } from "lucide-react";
import StatusPill from "../components/StatusPill";
import { label } from "./activityMeta";

function renderValue(value) {
  if (value === null || value === undefined || value === "") return "None";
  if (typeof value === "object") return JSON.stringify(value, null, 2);
  return String(value);
}

function severityType(severity) {
  if (severity === "danger") return "danger";
  if (severity === "warning") return "warning";
  if (severity === "success") return "success";
  return "info";
}

export default function ActivityDetailDrawer({ activity, onClose, onNavigate }) {
  if (!activity) return null;

  const metadata = Object.entries(activity.metadata || {});

  return (
    <div className="admin-modal-backdrop activity-detail-backdrop">
      <aside className="activity-detail-drawer" role="dialog" aria-modal="true">
        <header>
          <div>
            <span className="admin-eyebrow">Activity Detail</span>
            <h2>{activity.title}</h2>
          </div>
          <button type="button" onClick={onClose} aria-label="Close activity detail">
            <X size={19} />
          </button>
        </header>

        <p>{activity.description || "No description."}</p>

        <div className="activity-detail-pills">
          <StatusPill status={activity.category} label={activity.category_label || label(activity.category)} type="neutral" />
          <StatusPill status={activity.severity} label={activity.severity_label || label(activity.severity)} type={severityType(activity.severity)} />
        </div>

        <dl className="activity-detail-list">
          <div><dt>When</dt><dd>{new Date(activity.created_at).toLocaleString()}</dd></div>
          <div><dt>Actor</dt><dd>{activity.actor_name_snapshot || "System"}</dd></div>
          <div><dt>Source</dt><dd>{activity.source_label || "None"}</dd></div>
          <div><dt>Type</dt><dd>{label(activity.activity_type)}</dd></div>
        </dl>

        {activity.source_url && (
          <button type="button" className="btn btn--secondary" onClick={() => onNavigate(activity.source_url)}>
            <ExternalLink size={16} /> Open source
          </button>
        )}

        <section>
          <h3>Metadata</h3>
          {metadata.length ? (
            <dl className="activity-detail-list">
              {metadata.map(([key, value]) => (
                <div key={key}>
                  <dt>{label(key)}</dt>
                  <dd>{renderValue(value)}</dd>
                </div>
              ))}
            </dl>
          ) : (
            <p>No metadata.</p>
          )}
        </section>
      </aside>
    </div>
  );
}